import type { RawParams } from "@uirouter/core";

import categoryService from "app/common/services/categoryService";
import type { ICategory } from "app/common/services/categoryService.types";

import { extractCategoriesFromRouteParams } from "../routes/routeUtils";

export const getCategoriesFromParams = (params?: RawParams): ICategory[] => {
    const categoryIds = extractCategoriesFromRouteParams(params);

    return categoryIds
        .map((categoryId) => categoryService.categoryQueryParamToCategoryObject(categoryId))
        .filter(Boolean);
};
